import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles, Stack, Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import classNames from 'classnames';
import { ActionButton } from './action-button';
import { withCustomRendering } from '../custom-component';

const headerStyles = mergeStyles({
  padding: '0px 24px 0px 24px',
  borderStyle: 'solid',
  borderWidth: '0px 0px 1px 0px',
  borderColor: '#EDEBE9',
});

const headerStackStyles = {
  root: {
    height: 56,
  },
};

const titleStyles = mergeStyles({
  fontSize: 18,
  fontWeight: 600,
});

const Header = ({
  title, actionButton, actionButtonDynamic, as,
}) => {
  const i18n = useContext(I18nContext);
  return (
    <div className={classNames('panel-header', headerStyles)}>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center" styles={headerStackStyles}>
        <Text className={classNames('title', titleStyles)} as={as}>{i18n.getString(title)}</Text>
        {actionButton && <ActionButton {...actionButton} {...actionButtonDynamic} />}
      </Stack>
    </div>
  );
};

Header.propTypes = {
  actionButton: PropTypes.shape({}),
  actionButtonDynamic: PropTypes.shape({}),
  title: PropTypes.string.isRequired,
  as: PropTypes.string,
};

Header.defaultProps = {
  actionButton: null,
  actionButtonDynamic: null,
  as: 'span',
};

const HeaderWrapped = withCustomRendering(Header);

export { HeaderWrapped as Header };
